import { useAuthStore } from "@/store/AuthStore.ts";
import { useUserInfoStore } from "@/store/userInfo.ts";

export function useLogout() {
  const authStore = useAuthStore();
  const userInfoStore = useUserInfoStore();

  function logout() {
    authStore.logout();
    userInfoStore.clearCache();
  }

  return { logout };
}
